// Created by: Imran Khan July 2026
import React, { useMemo } from "react";
import { Line } from "react-chartjs-2";
import {
  Chart,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
} from "chart.js";
import { FY_MONTHS } from "./financialYearUtils";

Chart.register(CategoryScale, LinearScale, PointElement, LineElement, Tooltip, Legend);

const SERIES = [
  { key: "enquiries", label: "Enquiries", color: "#7B61FF" },
  { key: "siteVisits", label: "Site Visits", color: "#2196F3" },
  { key: "offers", label: "Offers", color: "#00BCD4" },
  { key: "orders", label: "Orders", color: "#4CAF50" },
  { key: "ordersCompleted", label: "Orders Completed", color: "#1565C0" },
];

export default function DashboardLineChart({ title, monthlyTrends }) {
  const chartData = useMemo(() => {
    const toMap = (rows = []) =>
      Object.fromEntries(rows.map((row) => [row.month, row.value]));

    const maps = SERIES.reduce((acc, series) => {
      acc[series.key] = toMap(monthlyTrends?.[series.key]);
      return acc;
    }, {});

    return {
      labels: FY_MONTHS,
      datasets: SERIES.map((series) => ({
        label: series.label,
        data: FY_MONTHS.map((month) => maps[series.key]?.[month] ?? 0),
        borderColor: series.color,
        backgroundColor: series.color,
        tension: 0.35,
        pointRadius: 3,
      })),
    };
  }, [monthlyTrends]);

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { position: "bottom" },
    },
    scales: {
      y: { beginAtZero: true, ticks: { precision: 0 } },
    },
  };

  return (
    <div className="fy-panel fy-panel-chart">
      {title && <h5 className="fy-panel-title">{title}</h5>}
      <div className="fy-chart-container">
        <Line data={chartData} options={options} />
      </div>
    </div>
  );
}
